import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from 'react';
import classnames from 'classnames2';
import linkStyles from './Link.scss';
export function createLink(displayName, linkStyle) {
  var LinkComponent = function LinkComponent(_ref, ref) {
    var _ref$as = _ref.as,
        as = _ref$as === void 0 ? 'a' : _ref$as,
        text = _ref.text,
        dataTest = _ref.dataTest,
        onClick = _ref.onClick,
        href = _ref.href,
        openInNewTab = _ref.openInNewTab,
        rest = _objectWithoutProperties(_ref, ["as", "text", "dataTest", "onClick", "href", "openInNewTab"]);

    var HtmlElement = as;
    return React.createElement(HtmlElement, Object.assign({
      ref: ref,
      "data-test": dataTest,
      className: classnames(linkStyles.link, linkStyle),
      onClick: onClick ? onClick : null,
      href: as === 'a' ? href : null,
      target: openInNewTab ? '_blank' : ''
    }, rest), text);
  };

  LinkComponent.displayName = displayName;
  return forwardRef(LinkComponent);
}
export var Link = {
  Quiet: createLink('Link.Quiet', linkStyles.quiet),
  Standard: createLink('Link.Standard', linkStyles.standard),
  Prominent: createLink('Link.Prominent', linkStyles.prominent)
};